import type TauriDatabase from "@tauri-apps/plugin-sql";
import { type Database as BunDatabase } from "bun:sqlite";

import { sql } from "../SqlString";

export type SqliteColumnInfo = {
	name: string;
	type: string;
	notnull: number;
	dflt_value: string | null;
	pk: number;
};

export type SqliteTableInfo = {
	name: string;
	columns: SqliteColumnInfo[];
};

/**
 * Gets information about all columns in a SQLite table, including hidden columns.
 */
export async function runGetTableXInfo(
	db: BunDatabase | TauriDatabase,
	tableName: string
): Promise<SqliteTableInfo> {
	const { statement, params } = sql`PRAGMA table_xinfo(${sql.lit(tableName)})`;

	const columns = (
		"prepare" in db ? db.prepare(statement, params).all() : await db.select(statement, params)
	) as SqliteColumnInfo[];

	return { name: tableName, columns };
}
